export const PHONE_NUMBER = '(858) 888-6211';
export const APPOINTMENT_ENDPOINT = '/api/appointments';
export const VALIDATE_ADDRESS_ENDPOINT = '/api/validate-address';
export const CALL_ME_ENDPOINT = '/api/call_me';

